/* Metra Daily — Theme JS */

// Dedupe ATC capture: main_form and sticky_cta sometimes both fire on a single
// click (observed Denver/Shakopee sessions, 9ms apart). Suppress duplicates for
// the same variant within 1.5s — the user can still add a second time after.
var __lastAtcKey = '';
var __lastAtcAt = 0;
function captureAddToCart(props) {
  var key = String(props.variant_id || '') + ':' + String(props.quantity || '');
  var now = Date.now();
  if (key === __lastAtcKey && (now - __lastAtcAt) < 1500) return;
  __lastAtcKey = key;
  __lastAtcAt = now;
  if (window.posthog) window.posthog.capture('add_to_cart', props);
}

document.addEventListener('DOMContentLoaded', function () {

  /* FAQ Accordion — grid-template-rows animation */
  document.querySelectorAll('.faq__question').forEach(function (question) {
    question.addEventListener('click', function () {
      var item = this.closest('.faq__item');
      var wasOpen = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.faq__item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
      });

      // Toggle clicked
      if (!wasOpen) {
        item.classList.add('is-open');
      }
    });
  });

  /* Mobile Drawer — open/close */
  var hamburger = document.querySelector('.nav__hamburger');
  var drawer = document.querySelector('.nav__mobile-drawer');
  var closeBtn = document.querySelector('.nav__mobile-close');

  if (hamburger && drawer) {
    hamburger.addEventListener('click', function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    }

    // Close on link click
    drawer.querySelectorAll('a:not(.nav__mobile-link--expandable)').forEach(function (link) {
      link.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  /* Mobile Products Expand */
  var expandBtn = document.querySelector('.nav__mobile-link--expandable');
  var mobileProducts = document.querySelector('.nav__mobile-products');

  if (expandBtn && mobileProducts) {
    expandBtn.addEventListener('click', function () {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isOpen);
      mobileProducts.classList.toggle('is-open');
    });
  }

  /* Mega menu — delayed close so diagonal mouse movement doesn't dismiss */
  var dropdownTrigger = document.querySelector('.nav__dropdown-trigger');
  if (dropdownTrigger) {
    var closeTimer = null;
    var megaMenu = dropdownTrigger.querySelector('.nav__mega-menu');

    dropdownTrigger.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      dropdownTrigger.classList.add('is-hovering');
    });

    dropdownTrigger.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        dropdownTrigger.classList.remove('is-hovering');
      }, 300);
    });

    if (megaMenu) {
      megaMenu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        dropdownTrigger.classList.add('is-hovering');
      });

      megaMenu.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          dropdownTrigger.classList.remove('is-hovering');
        }, 300);
      });
    }
  }

  /* Product Gallery — arrows, thumbnails, keyboard, and touch swipe */
  var galleryMain = document.querySelector('[data-gallery-main]');
  if (galleryMain) {
    var slides = galleryMain.querySelectorAll('[data-gallery-slide]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var counter = galleryMain.querySelector('[data-gallery-counter]');
    var prevBtn = galleryMain.querySelector('[data-gallery-prev]');
    var nextBtn = galleryMain.querySelector('[data-gallery-next]');
    var total = slides.length;
    var currentIndex = 0;

    function goToSlide(index) {
      // Wrap around
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      currentIndex = index;

      // Hide all slides, show selected
      slides.forEach(function (s) { s.classList.add('is-hidden'); });
      var target = galleryMain.querySelector('[data-gallery-slide="' + index + '"]');
      if (target) target.classList.remove('is-hidden');

      // Update active thumb
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });

      // Update counter
      if (counter) {
        counter.textContent = (index + 1) + ' / ' + total;
      }
    }

    // Thumbnail clicks
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(this.getAttribute('data-gallery-thumb'), 10);
        goToSlide(index);
      });
    });

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToSlide(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        goToSlide(currentIndex + 1);
      });
    }

    // Keep arrow navigation inside the gallery; radios use the same keys.
    galleryMain.closest('.pdp-hero__gallery').addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        goToSlide(currentIndex + (e.key === 'ArrowRight' ? 1 : -1));
      }
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb && thumb.tagName !== 'BUTTON' && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        goToSlide(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
      }
    });

    // Touch swipe support
    var touchStartX = 0;
    var touchEndX = 0;
    var minSwipe = 50;

    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    galleryMain.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > minSwipe) {
        if (diff > 0) {
          goToSlide(currentIndex + 1); // swipe left = next
        } else {
          goToSlide(currentIndex - 1); // swipe right = prev
        }
      }
    }, { passive: true });
  }

  /* ===========================
     CART DRAWER
     =========================== */
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  if (cartDrawer) {
    // Auto-open if redirected after add-to-cart
    var params = new URLSearchParams(window.location.search);
    if (params.get('cart_open') === '1') {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Clean URL
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('cart_open');
      history.replaceState(null, '', cleanUrl.toString());
    }
    // Open
    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // Close mobile nav if open
        if (drawer && drawer.classList.contains('is-open')) {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
        }
        cartDrawer.classList.add('is-open');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    // Close (delegated so it works after AJAX re-render)
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        cartDrawer.classList.remove('is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
        cartDrawer.classList.remove('is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });

    // Delegate qty change / remove clicks (works after AJAX re-render)
    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;

      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty = parseInt(btn.getAttribute('data-qty'), 10);

      // Disable buttons during update
      cartDrawer.querySelectorAll('[data-qty-change]').forEach(function (b) { b.disabled = true; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        refreshCartDrawer();
        updateHeaderCartCount(cart.item_count);
      })
      .catch(function () {
        refreshCartDrawer();
      });
    });
  }

  // Refresh cart drawer contents via AJAX (no page reload, drawer stays open)
  function refreshCartDrawer() {
    fetch(window.location.pathname, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var freshDrawer = doc.querySelector('[data-cart-drawer]');

      if (freshDrawer) {
        var panel = document.querySelector('.cart-drawer__panel');
        var freshPanel = freshDrawer.querySelector('.cart-drawer__panel');
        if (panel && freshPanel) {
          panel.innerHTML = freshPanel.innerHTML;
        }
      }

      // Update header cart count from fresh HTML
      var freshCount = doc.querySelector('[data-cart-drawer-count]');
      if (freshCount) {
        updateHeaderCartCount(freshCount.textContent.trim());
      }
    })
    .catch(function () {
      // Last resort: reload
      window.location.reload();
    });
  }

  // Update cart count in header
  function updateHeaderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-cart-drawer-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  // Intercept add-to-cart forms — AJAX add, then open drawer without reload.
  // The sticky CTA form is excluded: it has its own submit handler below with its
  // data-sticky-* inputs. Handling it here too fired two racing /cart/add requests
  // per tap, and this handler can't see [data-sticky-selling-plan], so its copy
  // landed WITHOUT the subscription plan — a duplicate full-price one-time line
  // ($140 next to the $105 protocol) in every sticky-CTA cart.
  document.querySelectorAll('form[action="/cart/add"]:not(.sticky-cta__form)').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalButtonHtml = submitBtn ? submitBtn.innerHTML : '';

      // Build payload explicitly from the hidden inputs
      var variantId = form.querySelector('[data-variant-id]');
      var quantityInput = form.querySelector('[data-quantity-input]');
      var sellingPlanInput = form.querySelector('[data-selling-plan-input]');

      var payload = {
        id: parseInt(variantId ? variantId.value : form.querySelector('[name="id"]').value),
        quantity: parseInt(quantityInput ? quantityInput.value : 1)
      };

      // Only include selling plan if it's not disabled
      if (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) {
        payload.selling_plan = parseInt(sellingPlanInput.value);
      }

      // Clear any previous error
      var errorEl = form.querySelector('[data-atc-error]') || (form.closest('[data-purchase-area]')
        ? form.closest('[data-purchase-area]').querySelector('[data-atc-error]')
        : null);
      if (errorEl) errorEl.textContent = '';

      // Disable button during submission
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('data-original-text', submitBtn.textContent);
        submitBtn.textContent = 'ADDING...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then(function (item) {
        captureAddToCart({
          product_id: item.product_id,
          product_title: item.product_title,
          variant_id: item.id,
          variant_title: item.variant_title,
          price: item.price / 100,
          quantity: item.quantity,
          source: 'main_form'
        });

        // Refresh drawer contents, then open it
        fetch(window.location.pathname)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var freshDrawer = doc.querySelector('[data-cart-drawer]');

            if (freshDrawer) {
              var panel = document.querySelector('.cart-drawer__panel');
              var freshPanel = freshDrawer.querySelector('.cart-drawer__panel');
              if (panel && freshPanel) {
                panel.innerHTML = freshPanel.innerHTML;
              }
            }

            // Update header count
            var freshCount = doc.querySelector('[data-cart-drawer-count]');
            if (freshCount) {
              updateHeaderCartCount(freshCount.textContent.trim());
            }

            // Open drawer
            var cartDrawer = document.querySelector('[data-cart-drawer]');
            if (cartDrawer) {
              cartDrawer.classList.add('is-open');
              cartDrawer.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }

            // Reset button
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('is-loading');
              submitBtn.innerHTML = originalButtonHtml;
            }
          });
      })
      .catch(function (err) {
        // Show visible error instead of silent fallback
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          submitBtn.innerHTML = originalButtonHtml;
        }
        var errEl = form.querySelector('[data-atc-error]') || (form.closest('[data-purchase-area]')
          ? form.closest('[data-purchase-area]').querySelector('[data-atc-error]')
          : null);
        if (errEl) {
          errEl.textContent = 'Something went wrong. Please try again.';
          setTimeout(function () { errEl.textContent = ''; }, 5000);
        }
      });
    });

    // Store original button text
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.setAttribute('data-original-text', submitBtn.textContent);
    }
  });

  /* Sticky CTA — show when main ATC button scrolls out of view */
  var stickyCta = document.querySelector('[data-sticky-cta]');
  var mainAtcBtn = stickyCta && stickyCta.hasAttribute('data-v3-offer')
    ? document.querySelector('[data-v3-purchase]')
    : document.querySelector('[data-atc-button]');

  if (stickyCta && mainAtcBtn) {
    // Use IntersectionObserver for precise trigger
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        } else {
          stickyCta.classList.add('is-visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainAtcBtn);

    // Sync sticky CTA with main form state
    function syncStickyCta() {
      if (stickyCta.hasAttribute('data-v3-offer')) return;
      var mainVariant = document.querySelector('[data-purchase-area] input[name="id"]');
      var mainSellingPlan = document.querySelector('[data-purchase-area] [data-selling-plan-input]');
      var mainPrice = document.querySelector('[data-atc-price]');
      var selectedPlan = document.querySelector('[data-purchase-area] .pdp-plan.is-selected');
      var stickyVariant = stickyCta.querySelector('[data-sticky-variant-id]');
      var stickySellingPlan = stickyCta.querySelector('[data-sticky-selling-plan]');
      var stickyPrice = stickyCta.querySelector('[data-sticky-price]');
      var stickyBtn = stickyCta.querySelector('.sticky-cta__btn');

      if (mainVariant && stickyVariant) {
        stickyVariant.value = mainVariant.value;
      }
      if (mainSellingPlan && stickySellingPlan) {
        if (mainSellingPlan.disabled) {
          stickySellingPlan.disabled = true;
        } else {
          stickySellingPlan.disabled = false;
          stickySellingPlan.value = mainSellingPlan.value;
        }
      }
      if (mainPrice && stickyPrice) {
        // On mobile the sticky bar is often the first price a visitor sees,
        // so the quarter price carries its per-day translation with it.
        var priceText = mainPrice.textContent;
        var perDayHtml = '';
        if (selectedPlan) {
          var priceMatch = priceText.match(/\$([0-9,.]+)/);
          var planDays = parseInt(selectedPlan.getAttribute('data-days'), 10);
          if (priceMatch && planDays > 0) {
            var cents = Math.round(parseFloat(priceMatch[1].replace(/,/g, '')) * 100);
            // Same floor/half-up/floor rounding as the Liquid per-day math.
            var perDay = Math.floor((Math.floor(cents * 10 / planDays) + 5) / 10);
            var offerTail = '';
            var o = window.metraOffer;
            if (o && o.endsLabel && typeof o.live === 'function' && (o.live() && (o.mode === 'auto' || document.cookie.indexOf('discount_code=PROTOCOL40') !== -1 || location.search.indexOf('promo=protocol40') !== -1)) && /first quarter/.test(priceText)) {
              offerTail = '<span class="sticky-cta__offer-tail"> · Expires ' + o.endsLabel + '</span>';
            }
            perDayHtml = '<span class="sticky-cta__perday">$' + (perDay / 100).toFixed(2) + ' a day' + offerTail + '</span>';
          }
        }
        stickyPrice.innerHTML = priceText.replace(/&/g, '&amp;').replace(/</g, '&lt;') + perDayHtml;
      }
      if (stickyBtn && selectedPlan && selectedPlan.getAttribute('data-cta-short') && !stickyBtn.disabled) {
        stickyBtn.textContent = selectedPlan.getAttribute('data-cta-short');
      }
    }

    // Sync on any interaction with the purchase area
    var purchaseArea = document.querySelector('[data-purchase-area]');
    if (purchaseArea) {
      purchaseArea.addEventListener('click', function () {
        setTimeout(syncStickyCta, 50);
      });
      purchaseArea.addEventListener('change', function () {
        setTimeout(syncStickyCta, 50);
      });
    }

    // Initial sync
    syncStickyCta();

    // Sticky CTA form also uses AJAX add-to-cart
    var stickyForm = stickyCta.querySelector('form');
    if (stickyForm) {
      stickyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        syncStickyCta();

        var stickyVariant = stickyForm.querySelector('[data-sticky-variant-id]');
        var stickySellingPlan = stickyForm.querySelector('[data-sticky-selling-plan]');
        var payload = {
          id: parseInt(stickyVariant.value),
          quantity: 1
        };
        if (stickySellingPlan && !stickySellingPlan.disabled && stickySellingPlan.value) {
          payload.selling_plan = parseInt(stickySellingPlan.value);
        }

        var btn = stickyForm.querySelector('button');
        var btnLabel = btn ? btn.textContent : 'ADD TO CART';
        if (btn) { btn.disabled = true; btn.textContent = 'ADDING...'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function (res) { return res.json(); })
        .then(function (item) {
          captureAddToCart({
            product_id: item.product_id,
            product_title: item.product_title,
            variant_id: item.id,
            variant_title: item.variant_title,
            price: item.price / 100,
            quantity: item.quantity,
            source: 'sticky_cta'
          });

          refreshCartDrawer();
          if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
          var cartDrawerEl = document.querySelector('[data-cart-drawer]');
          if (cartDrawerEl) {
            cartDrawerEl.classList.add('is-open');
            cartDrawerEl.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        })
        .catch(function () {
          stickyForm.submit();
        });
      });
    }
  } else if (stickyCta) {
    // Funnel pages: use data-funnel-trigger as the observer target
    var funnelTrigger = document.querySelector('[data-funnel-trigger]');
    if (funnelTrigger) {
      var funnelObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyCta.classList.remove('is-visible');
            stickyCta.setAttribute('aria-hidden', 'true');
          } else {
            stickyCta.classList.add('is-visible');
            stickyCta.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0 });
      funnelObserver.observe(funnelTrigger);
    } else {
      // Generic fallback: show after 600px scroll
      window.addEventListener('scroll', function () {
        if (window.scrollY > 600) {
          stickyCta.classList.add('is-visible');
        } else {
          stickyCta.classList.remove('is-visible');
        }
      }, { passive: true });
    }
  }

  /* Brag Bar — copy code + dismiss with TTL */
  document.querySelectorAll('[data-brag-bar]').forEach(function (bar) {
    var ttlDays = parseInt(bar.getAttribute('data-brag-bar-ttl'), 10) || 7;
    var statusTimers = [];

    function setStatus(button, text) {
      var status = button.querySelector('[data-brag-bar-status]');
      if (status) status.textContent = text;
      button.classList.add('is-copied');
      var timer = setTimeout(function () {
        button.classList.remove('is-copied');
        if (status) status.textContent = '';
      }, 2000);
      statusTimers.push(timer);
    }

    function copyCode(button) {
      var code = button.getAttribute('data-brag-bar-copy');
      if (!code) return;

      var done = function () { setStatus(button, 'COPIED'); };
      var fail = function () { setStatus(button, 'COPY FAILED'); };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done).catch(function () {
          fallbackCopy(code) ? done() : fail();
        });
      } else {
        fallbackCopy(code) ? done() : fail();
      }
    }

    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      return ok;
    }

    bar.querySelectorAll('[data-brag-bar-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () { copyCode(btn); });
    });

    var dismissBtn = bar.querySelector('[data-brag-bar-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        bar.hidden = true;
        try {
          localStorage.setItem('metra:brag-bar-dismissed', JSON.stringify({
            expires: Date.now() + ttlDays * 24 * 60 * 60 * 1000
          }));
        } catch (e) {}
      });
    }
  });

});


/* ============================================================
 * R02 scroll-driven bottle animation — JS fallback for browsers
 * that don't support CSS animation-timeline (Safari, Firefox).
 *
 * Drives the bottle empty/full state off scroll position when the
 * section is visible. CSS variable --bottle-progress (0 = full,
 * 1 = empty) controls clip-path; data-bottle-stage controls mark colors.
 * ============================================================ */
(function () {
  if (typeof window === 'undefined') return;

  // Skip if the browser already supports scroll-timeline (CSS handles it natively)
  if (CSS && CSS.supports && CSS.supports('animation-timeline', 'view()')) {
    return;
  }

  // Skip if reduced-motion is requested
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bottles = document.querySelectorAll('.bottle-r02');
    if (!bottles.length) return;

    bottles.forEach(function (bottle) {
      var section = bottle.closest('.listicle-reason') || bottle.parentElement;
      if (!section) return;

      bottle.setAttribute('data-bottle-progress', '');
      bottle.style.setProperty('--bottle-progress', '0');

      function update() {
        var rect = section.getBoundingClientRect();
        var viewportH = window.innerHeight || document.documentElement.clientHeight;
        // 0 when the section is fully visible (top at viewportH - sectionH),
        // 1 when the section's top reaches viewport top (rect.top = 0).
        var distance = viewportH - rect.height;
        var raw;
        if (distance > 0) {
          raw = (distance - rect.top) / distance;
        } else {
          // Section taller than viewport — start draining as soon as top enters viewport
          raw = -rect.top / Math.max(1, rect.height);
        }
        if (raw < 0) raw = 0;
        if (raw > 1) raw = 1;

        // Buffer: keep the bottle full for the first 30% of contain phase,
        // then drain linearly across the remaining 70%.
        var BUFFER = 0.30;
        var progress = raw < BUFFER ? 0 : (raw - BUFFER) / (1 - BUFFER);

        bottle.style.setProperty('--bottle-progress', progress.toFixed(3));

        // Determine bottle stage 0-7 for mark light-up (each mark = ~14% of drain)
        var stage = Math.floor(progress * 7);
        if (stage > 7) stage = 7;
        bottle.setAttribute('data-bottle-stage', String(stage));
      }

      // Update on scroll (throttled via rAF) and resize
      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () { update(); ticking = false; });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', update, { passive: true });

      // Only update while section is roughly near the viewport (perf)
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', onScroll, { passive: true });
              update();
            } else {
              window.removeEventListener('scroll', onScroll);
            }
          });
        }, { rootMargin: '50% 0px 50% 0px' });
        observer.observe(section);
      }

      update();
    });
  });
})();
